export const environment = {
  production: false,
  mockAuthentication: true,
  mockUser: 'onafriq',
  mockPassword: 'onafriq',
  jwtSecret: 'secret1234213',
  ENCRYPTION_KEY_256: 'C4CB6A8CBE79E722D6B24B3C354A3',
  jwtClaims: { permissions: 'admin' },
  apiUrl:
    'https://papiwebservice-temp.dev.apionafriq.com/PortalWebService/PartnerPortal',
  notificationUrl:
    'https://papinotification.dev.apionafriq.com/NotificationWebService',
  customerReportUrl: 'http://178.159.3.134:8080/MfsCustomerReportWebService',
};
